<template>
  <div class="header__div--box">
    <img :src="logo" alt="logo" class="img__logo">
    <div class="collapse__div" :style="{
      transform: isCollapse ? 'rotate(180deg)' : ''
    }">
      <i class="el-icon-s-fold" @click="collapseChange" />
    </div>
    <ul class="header__ul--nav">
      <li class="header__li--nav" v-for="item in headerNav" :key="item.name" @click="chooseNav(item)"
        :class="{ 'active__li': item.isActive }">
        <span v-text="item.meta.title"></span>
      </li>
    </ul>
    <Account></Account>
  </div>
</template>

<script>
import Account from "@/components/Account";

const checkHandle = function (list, checkPath) {
  let flag = false
  list && list.forEach(item => {
    if (item.path === checkPath) {
      flag = true
    } else if (item.children && item.children.length) {
      flag = checkHandle(item.children, checkPath)
    }
  })
  return flag
}
import store from "@/store";
import { newImport } from "@/utils/common";
import logo from "@/assets/logo_w.png";
export default {
  name: "headerNav",
  data() {
    return {
      isCollapse: false,
      logo
    }
  },
  components: {
    Account
  },
  computed: {
    headerNav: function () {
      return store.getters.getMenus
    }
  },
  watch: {
    $route: {
      handler: function (newVal) {
        if (!this.headerNav) {
          return
        }
        let activeObj = this.headerNav.reduce((pre, item) => {
          return item.isActive ? item : pre
        }, null)

        const nowPath = newVal.path
        let activeIsTrue = true
        if (!activeObj) {
          return
        }
        let navItem = {}
        this.headerNav.forEach(item => {
          if (checkHandle(item.children, nowPath)) {
            navItem = item
          }
        })
        store.dispatch('menu/changeMenu', navItem)
        // console.log('watch.$route', this.$router)
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    collapseChange: function () {
      this.isCollapse = !this.isCollapse
      this.$emit('collapseChange', this.isCollapse)
    },
    chooseNav: function (item) {
      let children = item.children.filter(v=>!v.hidden)
      console.log(children)
      if (children.length) {
        this.$router.push(children[0].path)
        store.dispatch('menu/changeMenu', item)
      } else {
        this.$message.warning('模块侧边菜单为空')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.header__div--box {
  height: 60px;
  background #42484f
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index 9999
}
.img__logo {
  height 40px
  margin 10px 20px
}
.header__ul--nav {
  height: 60px;
  //margin 0!important
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: auto;
}

.header__li--nav {
  font-size 18px
  font-weight bold
  //line-height 80px
  cursor pointer
  color: white
  margin-left 50px
}
@media screen and (max-width: 1400px) {
  .header__li--nav {
    font-size 18px
    font-weight bold
    //line-height 80px
    cursor pointer
    color: white
    margin-left 25px
  }
}
.header__li--nav:hover {
  color: #40a9ff
}
.collapse__div {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  padding: 0 20px;
  transition: all .6 ease;
  color: white;
}
.active__li{
  color: #40a9ff
}

</style>